import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import axios from "axios";
import { useEffect } from "react";
import {
  CapacitorPreferencesConstants,
  EndpointsConstants,
  MetricConstants,
  MetricTypeConstants,
} from "../components/Constants";
import OneOverlayLoader from "../utils/component-utils/OverlayLoader/OneOverlayLoader";
import { setCapacitorPreference } from "../utils/core-utils/capPreferencesUtils";
import { IS_DESKTOP_BROWSER } from "../utils/deviceDetectionUtil";
import { startMetric } from "../utils/metric-utils/metricUtils";
import { BE_URL } from "../utils/urlUtils";
import { getOrCreateStickySessionId } from "../utils/stickySessionIdManager";

// @author E42303 Judhjit Ganguli

interface AppAuthProps {
  accessTokenfetched: Function;
}

const AppAuth: React.FC<AppAuthProps> = ({ accessTokenfetched }) => {
  useEffect(() => {
    if (IS_DESKTOP_BROWSER) {
      postAuthCode();
    } else {
      if (
        window.location.href.indexOf("uat") != -1 &&
        window.location.href.includes("cmedmobile1.uat")
      ) {
        window.location.replace(
          "cmedmobileutbeta://mobileAuth?code=" +
            window.location.search.split("&")[0].split("=")[1],
        );
      } else if (
        window.location.href.indexOf("uat") != -1 &&
        window.location.href.includes("cmedmobile.uat")
      ) {
        window.location.replace(
          "cmedmobileut://mobileAuth?code=" +
            window.location.search.split("&")[0].split("=")[1],
        );
      } else {
        window.location.replace(
          "cmedmobile://mobileAuth?code=" +
            window.location.search.split("&")[0].split("=")[1],
        );
      }
    }
  }, []);

  async function postAuthCode() {
    // TODO connectionChange
    startMetric(
      MetricConstants.TIME_TO_FIRST_PAINT_LOGIN,
      MetricTypeConstants.TIMER,
    );
    const stickySessionCleintId = await getOrCreateStickySessionId();
    const json = await axios.post(
      BE_URL + EndpointsConstants.AUTH_ENDPOINT,
      {
        code: window.location.search.split("&")[0].split("=")[1],
        format: "json",
      },
      {
        params: {
          "x-sticky-session-id": stickySessionCleintId,
        },
      },
    );
    let accessToken = "";
    if (json.data && typeof json.data === "object") {
      if (json.data.access_token) {
        accessToken = json.data.access_token.replaceAll("\'", "");
      }
      if (json.data.refresh_token) {
        setCapacitorPreference(
          CapacitorPreferencesConstants.REFRESH_TOKEN,
          json.data.refresh_token,
        );
      }
    } else if (typeof json.data === "string") {
      accessToken = json.data.replaceAll("\'", "");
    }
    setCapacitorPreference(
      CapacitorPreferencesConstants.ACCESS_TOKEN,
      accessToken,
    );
    console.log("accessToken" + "=" + accessToken);
    accessTokenfetched();
  }

  return (
    <IonPage>
      {/* <IonHeader className='ion-no-border'>
        <IonToolbar>
          <IonTitle></IonTitle>
        </IonToolbar>
      </IonHeader> */}
      <IonContent>
        <OneOverlayLoader
          loadingText={["Authenticating...."]}
          shouldDisplayLogoAndSlogan={true}
        />
      </IonContent>
    </IonPage>
  );
};

export default AppAuth;
